import { useEffect } from "react";
import { QuizRow } from "./components/QuizRow";
import { useLearnStore } from "./store";
import { learnService } from "./service";
import { Button } from "components/Button";
import { QuizModal } from "./components/QuizModal";

export const LearnEarn = () => {
  const { quizes, setQuizModalOpen } = useLearnStore();

  useEffect(() => {
    learnService.getQuizzes();
  }, []);

  const openQuizModal = () => {
    setQuizModalOpen(true);
  };

  return (
    <div className="px-[14px] sm:px-[154px] flex flex-col items-center">
      <h1 className="mb-[50px] text-[24px] text-center px-[50px] sm:px-0 md:text-[36px] font-[700]">
        Quizes
      </h1>

      <div className="flex justify-end w-full mb-4">
        <Button onClick={openQuizModal}>
          New quiz
        </Button>
      </div>

      <table className="w-full table-auto bg-[#171717]">
        <thead className="bg-[#202020] text-nowrap">
          <tr className="divide-x divide-[#05050550]">
            <th className="w-1 text-center p-2 px-4">Name</th>
            <th className="w-1 text-start p-2 px-4">Max reward</th>
            <th className="w-1 text-center p-2 px-4">Questions count</th>
            <th className="flex-1 text-center p-2 px-4">Actions</th>
          </tr>
        </thead>

        <tbody className="divide-y divide-[#202020]">
          {quizes.map((quiz) => (
            <QuizRow quiz={quiz} />
          ))}
        </tbody>
      </table>

      <QuizModal />
    </div>
  );
}
